import * as React from "react";
const SvgLogin = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	"xmlns:svgjs": "http://svgjs.com/svgjs",
	viewBox: "0 0 48 48",
	height: 48,
	width: 48,
	...props
}, /* @__PURE__ */ React.createElement("title", null, "login 3 (From Streamline App : https://app.streamlineicons.com)"), /* @__PURE__ */ React.createElement("g", { transform: "matrix(2,0,0,2,0,0)" }, /* @__PURE__ */ React.createElement("path", {
	d: "M 20.25,18.754v1.5c0,0.828-0.672,1.5-1.5,1.5h-4.5 ",
	stroke: "currentColor",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M 14.25,3.754h4.5c0.828,0,1.5,0.672,1.5,1.5v1.5 ",
	stroke: "currentColor",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M 10.394,23.246l-9-1.286c-0.37-0.052-0.644-0.369-0.644-0.742V3.725c0-0.354,0.247-0.66,0.593-0.734l9-2.221 c0.405-0.087,0.804,0.171,0.89,0.576c0.011,0.052,0.017,0.105,0.017,0.158v21c0,0.414-0.336,0.75-0.75,0.75 C10.464,23.254,10.429,23.251,10.394,23.246z ",
	stroke: "currentColor",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M 18,9.753l-3,3h8.25 ",
	stroke: "currentColor",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M 18,15.753l-3-3 ",
	stroke: "currentColor",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M 7.875,11.629L7.875,11.629 ",
	stroke: "currentColor",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M 7.875,11.629 c-0.207,0-0.375,0.168-0.375,0.375c0,0.207,0.168,0.375,0.375,0.375c0.207,0,0.375-0.168,0.375-0.375c0-0.001,0-0.003,0-0.004 c0.001-0.207-0.166-0.374-0.373-0.375c-0.001,0-0.001,0-0.002,0",
	stroke: "currentColor",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
})));
export { SvgLogin as ReactComponent };
